import {storeFreeze} from 'ngrx-store-freeze';
import {environment} from '../../environments/environment';
import {MetaReducer} from '@ngrx/store';
import {AppState} from './AppState';

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [storeFreeze]
  : [];
